<template>
  <div class="tracking-category-creation-section" @click="openPopup">
    <img class="plus-image" :src="require('@/assets/onboarding/icons/icon-add.svg')">
    <div class="title">הוספת קטגוריה למעקב</div>
  </div>
</template>

<script>
import Segment from '../../../../../../../../../../Segment';
import ModalBus from '../../../../../../../../../../event-bus/modal-bus';
import CreateTrackingCategoryPopupFlow from './CreateTrackingCategoryPopupFlow.vue';

export default {
  name: 'TrackingCategoryCreationSection',
  methods: {
    openPopup() {
      Segment.trackUserInteraction('CreateTrackingCategory_Clicked');
      ModalBus.$emit('open', {
        component: CreateTrackingCategoryPopupFlow,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../../scss/mixins';

  .tracking-category-creation-section {
    @include cashflow-card;
    margin-bottom: 40px;
    padding: 17px 18px;
    display: flex;
    width: 100%;
    border: dashed 2px #dce3f5; // Color here is hardcoded because it is our riseup_blue with opacity. No opacity can be specified on border.
    border-radius: 3px;
    background-color: $riseup-white;
    cursor: pointer;

    .plus-image {
      margin-left: 13px;
      height: 25px;
    }

    .title {
      color: $riseup_blue;
      font-size: 20px;
      line-height: 1.25em;
    }
  }
</style>
